export interface BannerVisibilityInput {
  readonly isNative: boolean;
  readonly featureEnabled: boolean;
  readonly adFree: boolean;
}

export function shouldShowBanner(input: BannerVisibilityInput): boolean {
  return input.isNative && input.featureEnabled && !input.adFree;
}

export interface BannerReserveInput extends BannerVisibilityInput {
  readonly previewOverride: boolean;
}

export function shouldReserveBanner(input: BannerReserveInput): boolean {
  if (input.adFree) return false;
  return shouldShowBanner(input) || input.previewOverride;
}
